// NOTE (ngUpgrade Phase 0): the `UmsApp` module and the `app` / `_pb` globals are
// now defined in ./_module.ts and injected here by webpack's ProvidePlugin.
// This file only registers config/run/factory blocks against the shared `app`.
var inactiveInterval = null;



app.config(['$urlRouterProvider', '$httpProvider', '$qProvider', '$animateProvider', '$urlServiceProvider',
    function ($urlRouterProvider, $httpProvider, $qProvider, $animateProvider, $urlServiceProvider) {

        $animateProvider.classNameFilter(/angular-animate/);

        // $qProvider.errorOnUnhandledRejections(false); // uncomment if unhandled promise rejections cause problems
        $httpProvider.interceptors.push('httpResponseInterceptor');

        // $uibDirectiveConfig.
        $urlRouterProvider
            .otherwise('/');

        // ngUpgrade Phase 2 (hybrid router): defer URL syncing until main.ts starts it
        // after session restore, so both routers share one URL and the initial deep-link
        // is gated by the auth guard below with the real auth state.
        $urlServiceProvider.deferIntercept();
    }
]);

app.run(["AuthService", "$state", "$transitions", "$timeout", "usSpinnerService", '$uibModalStack', '$uibModal',
    function (AuthService, $state, $transitions, $timeout, usSpinnerService, $uibModalStack, $uibModal) {

        // Loop guard for the legacy modal-reentry redirect below (1.x has no notify:false).
        var skipModalReentry = false;

        function createCheckInactivity() {
            window.clearInterval(inactiveInterval);
            inactiveInterval = null;
            var intervalTime = localStorage.getItem('INACTIVE_SESSION_TIME') || 600000
            return window.setInterval(function () {
                if (window.mouseCoords === window.tmpmouseCoords) {
                    if ($state.current.data && $state.current.data.requireLogin) {
                        $uibModal.open({
                            controller: "SessionExpireWindowController",
                            templateUrl: _pb + 'components/session-expire-window/session-expire-window.html',
                            size: "md",
                            resolve: {
                                params: function () {
                                    return null;
                                }
                            }
                        }).result
                            .then(function (data) {
                                if (data && data.logout) {
                                    AuthService.logout().then(function () {
                                        window.clearInterval(inactiveInterval);
                                        inactiveInterval = null;
                                        $state.go('login');
                                    })
                                }

                            }, function () { });
                    }
                }
                else window.mouseCoords = window.tmpmouseCoords;
            }, +intervalTime)
        }

        // ngUpgrade Phase 2: was $rootScope.$on('$stateChangeStart', …). ui-router 1.x
        // does not fire the legacy events; this onBefore transition hook is the equivalent
        // auth guard. Returning a TargetState redirects; returning nothing allows the
        // transition. Session restore + the first sync happen in main.ts.
        $transitions.onBefore({}, function (trans) {
            var stateService = trans.router.stateService;
            var to = trans.to();
            var toParams = trans.params();
            var from = trans.from();
            var fromParams = trans.params('from');

            $uibModalStack.dismissAll();

            // Legacy modal-reentry: closing a modal (the `modal` param) on the same state
            // should not reload the view. 1.x has no notify:false — redirect once with
            // reload:false; skipModalReentry breaks the redirect loop.
            if (!skipModalReentry && fromParams.modal && fromParams.modal === "1" && from.name === to.name) {
                skipModalReentry = true;
                return stateService.target(to.name, toParams, { reload: false });
            }
            skipModalReentry = false;

            usSpinnerService.stop("root");

            if (to.name === 'login') {
                return;
            }

            // Authenticated user hitting the landing state → profile selection.
            if (AuthService.authenticated && to.name === "index") {
                return stateService.target('profile');
            }

            var needLogIn = to.data && to.data.requireLogin;
            if (!needLogIn) {
                return; // public page, allow
            }

            if (!AuthService.authenticated || (AuthService.user && AuthService.user.needSmsAuth)) {
                return stateService.target('login');
            }

            if (!inactiveInterval) inactiveInterval = createCheckInactivity();
        });
    }
]);

app.factory("ConfigService", [
    function () {
        return {
            datePickerOptions: {
                formatYear: 'yyyy',
                dateFormat: "dd-MM-yyyy"
            }
        };
    }
]);
